<template>
  <div class="snickers-voice-wrapper">
    <div class="paly-button">
      <img :src="playType ? play : push"  @click="playVedio"/>
      <img src="@/assets/imgs/snickers/text.png" />
    </div>
    <audio
      class="audio"
      @ended="audioEnd"
      @play="audioPlay"
      ref="audio"
    >
      <source :src="source[sourceNum]" type="audio/mpeg">
    </audio>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        playType: true,
        play: require('@/assets/imgs/snickers/play.png'),
        push: require('@/assets/imgs/snickers/push.png'),
        source: ['https://img.taotonggroup.com/09-29-152.WAV', 'https://img.taotonggroup.com/09-29-153%2000_00_11-00_00_18.mp3', 'https://img.taotonggroup.com/09-29-107.WAV'],
        sourceNum: 0
      }
    },

    methods: {
      playVedio() {
        // 播放媒体文件
        if (this.playType) {
          this.$refs.audio.play()
          this.playType = false
          this.$toast.loading({duration: 0, forbidClick: true, message: '加载中...'})
        }
      },
      audioEnd() {
        // 播放结束
        this.playType = true
      },
      audioPlay() {
        // 开始播放
        this.$toast.clear()
      }
    },

    created() {
      let sourceNum = this.$route.query.sourceNum
      if (sourceNum) this.sourceNum = Number(sourceNum) % this.source.length
    }
  }
</script>

<style lang="scss" scoped>
  .snickers-voice-wrapper {
    font-family: Microsoft YaHei;
    min-height: 100vh;
    background: rgb(237, 169, 168) url("https://img.taotonggroup.com/sn1.jpg") no-repeat;
    background-size: 100% auto;
    overflow: hidden;
    position: relative;
    .paly-button {
      position: absolute;
      width: 100%;
      height: 210px;
      bottom: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        &:nth-child(1) {
          width: 60px;
        }
        &:nth-child(2) {
          width: 180px;
        }
      }
    }
    .audio {
      display: none;
    }
  }
</style>
